import { IAuthUserPerfil, AuthUserPerfilId } from './IAuthUserPerfil';

export default ((): IAuthUserPerfil => {
  return {
    id: AuthUserPerfilId.Associado,
    nome: "Associado",

    associadoRoute: {
      assembleias: {
        pre: {
          ver: true,
          videos: {
            ver: true,
            participar: false
          },
          documentos: {
            ver: true,
            participar: false,
          },
          duvidasSugestoes: {
            ver: true,
            participar: true
          }
        },
        live: {
          ver: true,
          video: {
            ver: true,
            participar: false
          },
          documentos: {
            ver: true,
            participar: false,
          },
          duvidasSugestoes: {
            ver: true,
            participar: true
          }
        },
        pautas: {
          ver: true,
          participar: true
        }
      },
    },
  
    assessorRoute: {
      convocados: {
        view: false,
      },
      assembleias: {
        ver: false,
        alterarSituacao: false,
        bloquearConvocacao: false,
        convocar: false,
        documentos: {
          ver: false,
          editar: false,
        },
        participantes: {
          verTotal: false,
          confirmar: false
        },
        pautas: {
          ver: false,
          alterarSituacao: false,
          incluirVotoManual: false,
          editar: false,
          deletar: false
        },
        cadastroPauta: {
          cadastrar: false
        },
        videos: {
          editar: false,
        },
      },
  
      duvidasSugestoes: {
        ver: false,
        responder: false,
        alterarSituacao: false,
        incluirPergunta: false,
      }
    }
    
  }
})();